import { Container, Sprite } from 'pixi.js'
import gsap from 'gsap'
import { Spine } from '@esotericsoftware/spine-pixi'

export enum BackgroundActionType {
  open = 'open',
  normal = 'normal',
  spin = 'spin',
  stop = 'repair',
  finish = 'jump',
}

export class BackgroundService {
  public desktopBg: Container
  public bgContainer: Container
  public reelBgRef: Container
  private bgSpine: Spine
  private animationMap = new Map<BackgroundActionType, string>([
    [BackgroundActionType.open, 'anim_open'],
    [BackgroundActionType.normal, 'anim_normal'],
    [BackgroundActionType.spin, 'anim_spin'],
    [BackgroundActionType.stop, 'anim_repair'],
    [BackgroundActionType.finish, 'anim_jump'],
  ])

  public changeToFreeGame(toFreeGame: boolean) {
    const mg = this.desktopBg.getChildByName<Sprite>('mg') as Sprite
    const fg = this.desktopBg.getChildByName<Sprite>('fg') as Sprite

    if (toFreeGame) {
      mg.alpha = 1
      fg.alpha = 0
    }
    else {
      mg.alpha = 0
      fg.alpha = 1
    }

    const transition = gsap.timeline({
      onComplete: () => {
        transition.kill()
      },
    })
    const mgPlay = gsap.to(mg, {
      alpha: toFreeGame ? 0 : 1,
      duration: toFreeGame ? 0.1 : 0.5,
    })
    const fgPlay = gsap.to(fg, {
      alpha: toFreeGame ? 1 : 0,
      duration: toFreeGame ? 0.1 : 0.5,
    })
    if (toFreeGame) {
      transition.add(fgPlay)
      transition.add(mgPlay)
    }
    else {
      transition.add(mgPlay)
      transition.add(fgPlay)
    }
  }
}
